import { ButtonBase, Menu, MenuItem, Typography } from '@material-ui/core'
import React, { useState } from 'react'

import { getTranslate, lang } from '../../localization'
import { MonitoringUpdateRatePlaneFieldsType } from '../../types/monitoringUpdate'

interface RatePlaneLayerRowMenuProps {
  mayItemMenuRatePlane: {
    value: MonitoringUpdateRatePlaneFieldsType
    label: string
  }[]
  selectedRatePlaneRowMenu: MonitoringUpdateRatePlaneFieldsType
  setSelectedRatePlaneRowMenu: React.Dispatch<
    React.SetStateAction<MonitoringUpdateRatePlaneFieldsType>
  >
  onChangeSelectedItem: (newMenuItem: string) => void
}

export default function RatePlaneLayerRowMenu({
  mayItemMenuRatePlane,
  selectedRatePlaneRowMenu,
  setSelectedRatePlaneRowMenu,
  onChangeSelectedItem
}: RatePlaneLayerRowMenuProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  const handleChangeMenuItem = (
    selectedItem: MonitoringUpdateRatePlaneFieldsType
  ) => {
    onChangeSelectedItem?.(selectedItem)
    setSelectedRatePlaneRowMenu(selectedItem)
    handleCloseMenu()
  }
  return (
    <div>
      <ButtonBase aria-controls="simple-menu" onClick={handleOpenMenu}>
        <Typography variant="h5">
          {lang === 'en'
            ? getTranslate(selectedRatePlaneRowMenu).slice(0, 3) + '...'
            : selectedRatePlaneRowMenu.length > 4
            ? getTranslate(selectedRatePlaneRowMenu).slice(0, 4) + '...'
            : getTranslate(selectedRatePlaneRowMenu)}
        </Typography>
      </ButtonBase>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}>
        {mayItemMenuRatePlane.map((mayItem) => {
          return (
            <MenuItem
              key={mayItem.value}
              value={mayItem.value}
              onClick={() => handleChangeMenuItem(mayItem.value)}>
              {getTranslate(mayItem.label)}
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}
